/* global lozad */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import Swiper from 'swiper' // Swiper

jQuery(function($) {
  let accordionBtn = 'spmenu' // このIDを基準としたアコーディオン
  $(
    '#' + accordionBtn + '-open,#' + accordionBtn + '-close, .js-close-link'
  ).on('click', function() {
    $(
      '#' +
        accordionBtn +
        ',#' +
        accordionBtn +
        '-open,#' +
        accordionBtn +
        '-close'
    ).toggleClass('active')
    $('body').toggleClass('lock')
    $('#overlay').toggleClass('active')
  })

  lozad('.lozad,.chain', {
    // 画面に交差した要素をactive
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active')
    }
  }).observe()

  $(window).on('load scroll', function() {
    //固定ヘッダー
    var scrollY = window.pageYOffset //現在地
    if (scrollY >= 96) {
      //ヘッダーの高さ
      $('.l-header.scroll-top-in').addClass('active')
    } else {
      $('.l-header.scroll-top-in').removeClass('active')
    }
  })

  $(window).on('load scroll', function() {
    //TOPボタン
    var scrollY = window.pageYOffset //現在地
    if (scrollY >= 900) {
      $('.to-top').addClass('active')
    } else {
      $('.to-top').removeClass('active')
    }
  })

  $('.js-popup').magnificPopup({
    type: 'inline',
    removalDelay: 500,
    callbacks: {
      beforeOpen: function() {
        this.st.mainClass = this.st.el.attr('data-effect')
      }
    }
  })

  //ナビの処理
  // ナビゲーションのリンクを指定
  var navLink = $('.l-nav .header-nav-list li a')
  // 各コンテンツのページ上部からの開始位置と終了位置を配列に格納しておく
  var contentsArr = []
  for (var i = 0; i < navLink.length; i++) {
    // コンテンツのIDを取得
    var targetContents = navLink.eq(i).attr('href')
    // ページ内リンクでないナビゲーションが含まれている場合は除外する
    if (targetContents.charAt(0) === '#') {
      // ページ上部からコンテンツの開始位置までの距離を取得
      var targetContentsTop = $(targetContents).offset().top
      // ページ上部からコンテンツの終了位置までの距離を取得
      var targetContentsBottom =
        targetContentsTop + $(targetContents).outerHeight(true) - 1
      // 配列に格納
      contentsArr[i] = [targetContentsTop, targetContentsBottom]
    }
  }
  // 現在地をチェックする
  function currentCheck() {
    // 現在のスクロール位置を取得
    var windowScrolltop = $(window).scrollTop()
    var navHeight = 100
    for (var i = 0; i < contentsArr.length; i++) {
      // 現在のスクロール位置が、配列に格納した開始位置と終了位置の間にあるものを調べる
      if (
        contentsArr[i][0] - navHeight <= windowScrolltop &&
        contentsArr[i][1] - navHeight >= windowScrolltop
      ) {
        // 開始位置と終了位置の間にある場合、ナビゲーションにclass="active"をつける
        navLink.removeClass('active')
        navLink.eq(i).addClass('active')
        // i === contentsArr.length
      } else {
        if (contentsArr[0][0] - navHeight > windowScrolltop) {
          navLink.removeClass('active')
        }
      }
    }
  }
  // ページ読み込み時とスクロール時に、現在地をチェックする
  $(window).on('load scroll', function() {
    currentCheck()
  })
})
